import Promotions, { ViewMode } from '../../ports-frontend/Promotions';

export const SOCKET_ID = 'basecamp-container';

export const startPromotionsFlow = async (viewMode: ViewMode) => {
  await Promotions.startPromotions(SOCKET_ID, viewMode);
};
